<mat-drawer-container class="admin-view_container">
  <mat-drawer mode="side" opened #drawer>
    <nav>
      <div
        data-test-navigation-format
        class="admin-view_navigation-item"
        [routerLinkActive]="'admin-view_navigation-item--active'"
        [routerLink]="routes.format.route">
        <celum-icon class="admin-view_navigation-item-icon" [configuration]="routes.format.icon | wrapFn: toIconConfiguration"></celum-icon>
        <span class="admin-view_navigation-item-title">{{ 'FORMAT_LIST.TITLE' | translate }}</span>
      </div>
      <div
        data-test-navigation-spec
        class="admin-view_navigation-item"
        [routerLinkActive]="'admin-view_navigation-item--active'"
        [routerLink]="routes.specification.route">
        <celum-icon class="admin-view_navigation-item-icon" [configuration]="routes.specification.icon | wrapFn: toIconConfiguration"></celum-icon>
        <span class="admin-view_navigation-item-title">{{ 'SPECIFICATION_LIST.TITLE' | translate }}</span>
      </div>

      <div class="admin-view_administration-section">
        <p>{{ 'ADMIN_MENU.CELUM_ADMINISTRATION' | translate }}</p>
        <div
          data-test-navigation-process-view
          class="admin-view_navigation-item"
          [routerLinkActive]="'admin-view_navigation-item--active'"
          [routerLink]="routes.processView.route">
          <span class="admin-view_navigation-item-title">{{ 'PROCESS_VIEW.TITLE' | translate }}</span>
        </div>
      </div>
    </nav>
    <celum-collapse-button class="admin-view_collapse-button" [collapsed]="!drawer.opened" (changed)="drawer.toggle()"></celum-collapse-button>
  </mat-drawer>
  <mat-drawer-content>
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
